import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
@Component({
    selector: 'audit-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.css'],
    standalone: true,
    imports: [RouterLink, MatButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeComponent implements OnInit {

  logoutText = '';
  isLogout = '';
  appId = 1;

  private _Route = inject(ActivatedRoute);
  private _Router = inject(Router);

  ngOnInit() {

    // If the user already has a valid session, skip the welcome screen
    if (sessionStorage.getItem('accessToken') && !this._Route.snapshot.queryParamMap.get('isLogout') && !this._Route.snapshot.queryParamMap.get('isAutoLogout')) {
      this._Router.navigate(['/dashboard']);
      return;
    }

    this.isLogout = this._Route.snapshot.queryParamMap.get('isLogout');

    if (this.isLogout) {
      this.logoutText = 'You have logged out.';
    }
    else {
      const autologout = this._Route.snapshot.queryParamMap.get('isAutoLogout');
      this.isLogout = autologout;
      // this.isLogout = this._Route.snapshot.queryParamMap.get('isAutoLogout');

      if (this.isLogout) {
        this.logoutText = 'To protect your data you have been automatically logged out.';
      }

    }
  }

}
